"use strict";

function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _exportNames = {
  Avatar: true,
  BackgroundImage: true,
  Badge: true,
  BlockLink: true,
  Box: true,
  Button: true,
  Card: true,
  Container: true,
  Field: true,
  Flex: true,
  Heading: true,
  Hide: true,
  Icon: true,
  IconButton: true,
  Image: true,
  Input: true,
  Label: true,
  LargeButton: true,
  Link: true,
  Loading: true,
  OutlineButton: true,
  Section: true,
  Sheet: true,
  Slider: true,
  Submit: true,
  Text: true,
  theme: true,
  ThemeProvider: true
};
Object.defineProperty(exports, "Avatar", {
  enumerable: true,
  get: function get() {
    return _Avatar["default"];
  }
});
Object.defineProperty(exports, "BackgroundImage", {
  enumerable: true,
  get: function get() {
    return _BackgroundImage["default"];
  }
});
Object.defineProperty(exports, "Badge", {
  enumerable: true,
  get: function get() {
    return _Badge["default"];
  }
});
Object.defineProperty(exports, "BlockLink", {
  enumerable: true,
  get: function get() {
    return _BlockLink["default"];
  }
});
Object.defineProperty(exports, "Box", {
  enumerable: true,
  get: function get() {
    return _Box["default"];
  }
});
Object.defineProperty(exports, "Button", {
  enumerable: true,
  get: function get() {
    return _Button["default"];
  }
});
Object.defineProperty(exports, "Card", {
  enumerable: true,
  get: function get() {
    return _Card["default"];
  }
});
Object.defineProperty(exports, "Container", {
  enumerable: true,
  get: function get() {
    return _Container["default"];
  }
});
Object.defineProperty(exports, "Field", {
  enumerable: true,
  get: function get() {
    return _Field["default"];
  }
});
Object.defineProperty(exports, "Flex", {
  enumerable: true,
  get: function get() {
    return _Flex["default"];
  }
});
Object.defineProperty(exports, "Heading", {
  enumerable: true,
  get: function get() {
    return _Heading["default"];
  }
});
Object.defineProperty(exports, "Hide", {
  enumerable: true,
  get: function get() {
    return _Hide["default"];
  }
});
Object.defineProperty(exports, "Icon", {
  enumerable: true,
  get: function get() {
    return _Icon["default"];
  }
});
Object.defineProperty(exports, "IconButton", {
  enumerable: true,
  get: function get() {
    return _IconButton["default"];
  }
});
Object.defineProperty(exports, "Image", {
  enumerable: true,
  get: function get() {
    return _Image["default"];
  }
});
Object.defineProperty(exports, "Input", {
  enumerable: true,
  get: function get() {
    return _Input["default"];
  }
});
Object.defineProperty(exports, "Label", {
  enumerable: true,
  get: function get() {
    return _Label["default"];
  }
});
Object.defineProperty(exports, "LargeButton", {
  enumerable: true,
  get: function get() {
    return _LargeButton["default"];
  }
});
Object.defineProperty(exports, "Link", {
  enumerable: true,
  get: function get() {
    return _Link["default"];
  }
});
Object.defineProperty(exports, "Loading", {
  enumerable: true,
  get: function get() {
    return _Loading["default"];
  }
});
Object.defineProperty(exports, "OutlineButton", {
  enumerable: true,
  get: function get() {
    return _OutlineButton["default"];
  }
});
Object.defineProperty(exports, "Section", {
  enumerable: true,
  get: function get() {
    return _Section["default"];
  }
});
Object.defineProperty(exports, "Sheet", {
  enumerable: true,
  get: function get() {
    return _Sheet["default"];
  }
});
Object.defineProperty(exports, "Slider", {
  enumerable: true,
  get: function get() {
    return _Slider["default"];
  }
});
Object.defineProperty(exports, "Submit", {
  enumerable: true,
  get: function get() {
    return _Submit["default"];
  }
});
Object.defineProperty(exports, "Text", {
  enumerable: true,
  get: function get() {
    return _Text["default"];
  }
});
Object.defineProperty(exports, "theme", {
  enumerable: true,
  get: function get() {
    return _theme["default"];
  }
});
Object.defineProperty(exports, "ThemeProvider", {
  enumerable: true,
  get: function get() {
    return _ThemeProvider["default"];
  }
});

var _Avatar = _interopRequireDefault(require("./Avatar"));

var _BackgroundImage = _interopRequireDefault(require("./BackgroundImage"));

var _Badge = _interopRequireDefault(require("./Badge"));

var _BlockLink = _interopRequireDefault(require("./BlockLink"));

var _Box = _interopRequireDefault(require("./Box"));

var _Button = _interopRequireDefault(require("./Button"));

var _Card = _interopRequireDefault(require("./Card"));

var _Container = _interopRequireDefault(require("./Container"));

var _Field = _interopRequireDefault(require("./Field"));

var _Flex = _interopRequireDefault(require("./Flex"));

var _Heading = _interopRequireDefault(require("./Heading"));

var _Hide = _interopRequireDefault(require("./Hide"));

var _Icon = _interopRequireDefault(require("./Icon"));

var _IconButton = _interopRequireDefault(require("./IconButton"));

var _Image = _interopRequireDefault(require("./Image"));

var _Input = _interopRequireDefault(require("./Input"));

var _Label = _interopRequireDefault(require("./Label"));

var _LargeButton = _interopRequireDefault(require("./LargeButton"));

var _Link = _interopRequireDefault(require("./Link"));

var _Loading = _interopRequireDefault(require("./Loading"));

var _OutlineButton = _interopRequireDefault(require("./OutlineButton"));

var _Section = _interopRequireDefault(require("./Section"));

var _Sheet = _interopRequireDefault(require("./Sheet"));

var _Slider = _interopRequireDefault(require("./Slider"));

var _Submit = _interopRequireDefault(require("./Submit"));

var _Text = _interopRequireDefault(require("./Text"));

var _theme = _interopRequireWildcard(require("./theme"));

Object.keys(_theme).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _theme[key];
    }
  });
});

var _ThemeProvider = _interopRequireDefault(require("./ThemeProvider"));

function _getRequireWildcardCache() {
  if (typeof WeakMap !== "function") return null;
  var cache = new WeakMap();

  _getRequireWildcardCache = function _getRequireWildcardCache() {
    return cache;
  };

  return cache;
}

function _interopRequireWildcard(obj) {
  if (obj && obj.__esModule) {
    return obj;
  }

  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      "default": obj
    };
  }

  var cache = _getRequireWildcardCache();

  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }

  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;

  for (var key in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;

      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }

  newObj["default"] = obj;

  if (cache) {
    cache.set(obj, newObj);
  }

  return newObj;
}

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}